import { useCallback, useState } from 'react';
import { showApiErrorToast } from '@/utils/errors';

export function useReportExport(run: () => Promise<void>) {
  const [isRunning, setRunning] = useState(false);

  const start = useCallback(() => {
    setRunning(true);
    run()
      .catch((error: unknown) => showApiErrorToast(error, 'Failed to build the spreadsheet'))
      .finally(() => setRunning(false));
  }, [run]);

  return { isRunning, run: start };
}
